<template>
    <splash-component />
    <home />
</template>

<script>
import Home from "../views/Home.vue";
import SplashComponent from "@/components/SplashComponent.vue";

export default {
    components: {
        Home,
        SplashComponent
    }
};
</script>
